import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/mock-interview-practice",
  title: "Mock Interview Practice",
  seoTitle: "Mock Interview Practice with AI Feedback | HiredCoach",
  seoDescription:
    "Practice mock interviews with AI feedback, sharpen common interview answers, and turn Coach U frameworks into real interview reps.",
  heroEyebrow: "Mock interview practice",
  heroHeadline: "Interview prep feels good... until you actually have to talk",
  heroSubhead:
    "You can read perfect answers all day. Does not mean you can say one. Mock practice is where you hear the rambling, the weak examples, and the part where your point disappears.",
  heroPrimaryCta: "Run a quick mock",
  heroPanelEyebrow: "What actually happens",
  heroPanelTitle: "You hear the weak spots fast",
  heroPanelBullets: [
    "You ramble longer than you think",
    "Your good example is less clear than you hoped",
    "You lose your point halfway through",
  ],
  heroPanelFooter: "That is normal. That is what you fix.",
  frameworkTitle: "What this actually looks like",
  frameworkBullets: [
    "Real questions you will actually get.",
    "You answering them out loud, not just in your head.",
    "Immediate feedback on what did not land.",
    "Trying again right away while it is still fresh.",
  ],
  exampleTitle: "What this should feel like",
  exampleBlocks: [
    "You answer a question. It is kind of rough.",
    "You tighten it. You try again.",
    "After a few reps, something clicks.",
    "You stop guessing what sounds good because you can hear it.",
  ],
  mistakesTitle: "Why people skip this and regret it",
  mistakes: [
    "They prep in their head and assume it will come out fine.",
    "They have never actually said the answer out loud.",
    "They get their first real feedback during the actual interview.",
    "They confuse reading prep with actual practice.",
  ],
  ctaEyebrow: "Coach U + practice",
  ctaTitle: "Build interview confidence",
  ctaBullets: [
    "Learn what a strong answer sounds like",
    "Try to say it yourself",
    "Hear where it breaks",
    "Fix it and go again",
  ],
  ctaInfoCard: {
    title: "Coach U interview library",
    path: "/public-learn",
    description: "Use the Coach U guides as input, then practice them in a mock interview.",
  },
  ctaActionTitle: "Run a quick mock",
  ctaActionDescription: "Say your answer out loud, hear what is off, fix it, and go again.",
  relatedTitle: "More interview questions worth actually practicing",
  relatedLinks: [
    {
      title: "Common Interview Questions",
      path: "/common-interview-questions",
      description: "Use this hub page to prepare for the most common interview questions and jump into deeper answer guides and mock interview practice.",
    },
    {
      title: "How to Prepare for an Interview",
      path: "/how-to-prepare-for-an-interview",
      description: "A practical interview preparation guide covering research, answer practice, story prep, and mock interview rehearsal.",
    },
    {
      title: "Behavioral Interview Questions and Answers",
      path: "/behavioral-interview-questions",
      description: "Review common behavioral interview questions, how to answer them well, and how to practice them with AI feedback.",
    },
  ],
  faqs: [
    { question: "Are mock interviews worth it?", answer: "Yes. What sounds good in your head often falls apart when you say it." },
    { question: "What should you practice in a mock interview?", answer: "Practice your opening, common questions, behavioral stories, and the way you recover when a follow-up throws you off a bit." },
  ],
};

export default function MockInterviewPracticePage() {
  return <SeoLandingTemplate page={page} />;
}
